<template>
  <header>
    <div class="header-container w">
      <router-link to="/" exact class="logo">
        <svg-icon icon-class="icon_logo" class-name="icon_logo"></svg-icon>
      </router-link>

      <ul class="nav">
        <li>
          <router-link to="/" exact>首页</router-link>
        </li>
        <li>
          <router-link to="/solve">解决方案</router-link>
        </li>
        <li>
          <router-link to="/service">客户服务</router-link>
        </li>
        <li>
          <router-link to="/case">客户案例</router-link>
        </li>
        <li>
          <router-link to="/about">关于我们</router-link>
        </li>
        <li class="nav-try">
          <router-link to="/try">申请使用</router-link>
        </li>
        <li>
          <a href="https://hcs.houkeyun.com/">企业登录</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  background: #fff;
  .header-container {
    height: 58px;
    padding: 13px 0;
    .logo {
      background: transparent !important;
      float: left;
      .icon_logo {
        width: 142px;
        height: 30px;
      }
    }
    .nav {
      float: right;
      @include clearfix;
      li {
        float: left;
        height: 32px;
        border-radius: 3px;
        text-align: center;
        line-height: 32px;
        padding: 0 16px;
        margin-left: 16px;
        a {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .nav-try {
        background: #f08300;
        a {
          color: #fff !important;
        }
      }
    }
  }
}
</style>
